/**
 *
 */

import React, { forwardRef, useImperativeHandle, useRef } from "react";

export type AccordionSectionHandle = {
  open: () => void;
  close: () => void;
  toggle: () => void;
  isOpen: () => boolean;
};

type Props = {
  id?: string;
  title: string;
  defaultOpen?: boolean;
  children?: React.ReactNode;
};

const AccordionSection = forwardRef<AccordionSectionHandle, Props>(
  ({ id, title, defaultOpen, children }, ref) => {
    const detailsRef = useRef<HTMLDetailsElement>(null);

    useImperativeHandle(ref, () => ({
      open: () => {
        const el = detailsRef.current;
        if (!el) return;
        if (!el.open) el.open = true;
      },
      close: () => {
        const el = detailsRef.current;
        if (!el) return;
        if (el.open) el.open = false;
      },
      toggle: () => {
        const el = detailsRef.current;
        if (!el) return;
        el.open = !el.open;
      },
      isOpen: () => !!detailsRef.current?.open,
    }));

    return (
      <details
        id={id}
        ref={detailsRef}
        className="psa-acc"
        {...(defaultOpen ? { open: true } : {})}
      >
        <summary className="psa-acc__summary">{title}</summary>
        <div className="psa-acc__anim">
          <div className="psa-acc__panel">{children}</div>
        </div>
      </details>
    );
  }
);

export default AccordionSection;
